<template>
    <div class="button" @click="$emit('click')">

        <span v-if="btnContent" class="buttonText">{{btnContent}}</span>
        
        <span v-if="iconType" class="buttonIcon">
            <ArrowIcon v-if="iconType == 'arrow'"/>
            <PlusIcon v-if="iconType == 'plus'"/>
            <ReplayIcon v-if="iconType == 'replay'"/>
        </span>

    </div>
</template>

<script>
import ArrowIcon from '@/components/icons/ArrowIcon'
import PlusIcon from '@/components/icons/PlusIcon'
import ReplayIcon from '@/components/icons/ReplayIcon'
export default {
    name: 'ButtonPulse',
    props: ['btnContent', 'iconType'],

    components: {
        ArrowIcon, PlusIcon, ReplayIcon
    }
}
</script>

<style lang="scss" scoped>
.button {
    background-color: $colour__accent1;
    color: $colour__primary1;
    padding: 1rem 1.25rem;
    display: inline-block;
    cursor: pointer;
    border: none;
    vertical-align: middle;
    line-height: 2rem;
    text-transform: uppercase;
    
    &:active,
    &:focus {
        outline-width: 0px;
        outline: none;
    }
}

.buttonContainer {
    position: relative;
}

.buttonText {
    vertical-align: middle;
}

.buttonIcon {
    display: inline-block;
    height: 2rem;
    width: 2rem;
    vertical-align: middle;
    .buttonText + & {
        margin-left: 1.5rem;
    }
}
</style>
